import { AppState } from '../../../../types'
import { environmentSelectorSelectors } from '../../../../common/environment/selectors'
import { resourceSelectorSelectors } from '../../../../common/resource/selectors'
import { versionSelectorSelectors } from '../../../../common/version/selectors'
import { apiPolicySelectorSelectors } from '../../../../common/policies/selectors'

export const basicAlertModalSelectors: any = {
  getAll: (state: AppState) => state.monitoring.basicAlertModal,
  isBasicAlertModalOpened: (state: AppState) => basicAlertModalSelectors.getAll(state).isBasicAlertModalOpened,
  apiResponseCodesLimit: (state: AppState) => basicAlertModalSelectors.getAll(state).apiResponseCodesLimit,
  existingAlert: (state: AppState) => basicAlertModalSelectors.getAll(state).existingAlert,
  servers: (state: AppState) => basicAlertModalSelectors.getAll(state).servers,
  serversLoading: (state: AppState) => basicAlertModalSelectors.getAll(state).serversLoading,
  users: (state: AppState) => basicAlertModalSelectors.getAll(state).users,
  environmentSelector: environmentSelectorSelectors<AppState>((state: AppState) => basicAlertModalSelectors.getAll(state).environmentSelector),
  resourceSelector: resourceSelectorSelectors<AppState>((state: AppState) => basicAlertModalSelectors.getAll(state).resourceSelector),
  versionSelector: versionSelectorSelectors<AppState>((state: AppState) => basicAlertModalSelectors.getAll(state).versionSelector),
  policySelector: apiPolicySelectorSelectors<AppState>((state: AppState) => basicAlertModalSelectors.getAll(state).policySelector),
}
